import { render, staticRenderFns } from "./SendEmailPanel.vue?vue&type=template&id=2ed4cda0&scoped=true"
import script from "./SendEmailPanel.vue?vue&type=script&lang=js"
export * from "./SendEmailPanel.vue?vue&type=script&lang=js"
import style0 from "./SendEmailPanel.vue?vue&type=style&index=0&id=2ed4cda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed4cda0",
  null
  
)

export default component.exports